import React from "react";
import { BarLoader } from "react-spinners";

export default function() {
  const { style } = this.props;
  return (
    <div className="overlay" style={{ ...style }}>
      <div className="spinner">
        <BarLoader width={200} color={"var(--primary-color)"} />
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/overlay/view.js